module.exports = __webpack_public_path__ + "static/media/3.b311a1b6.png";